import React from 'react';
import { Link } from 'react-router-dom';
import { useT } from '../i18n';
import useCredits from '../hooks/useCredits';
import './CreditsBadge.css';

// ── CREDITS, IN THE HEADER ───────────────────────────────────────────────────
// Signed-in only, and silent until the balance is actually known: rendering
// "0" while the first snapshot is still in flight tells people they are broke
// when they are not, and the flash to the real number afterwards reads as a bug.
//
// A LINK, not a button with a handler — so it opens in a new tab, shows its
// destination on hover, and needs no navigation code of its own.
//
// The sparkle is the same glyph the AI entry points already use (the landing's
// AI card and header link). Reused rather than invented: credits are what those
// buttons spend, and a third unrelated icon would make it a separate idea.
export default function CreditsBadge() {
  const { t } = useT();
  const { credits, known } = useCredits();

  if (!known) return null;

  return (
    <Link
      to="/plans"
      className={`crb${credits <= 0 ? ' crb--empty' : ''}`}
      title={t('crb_title')}
      aria-label={`${credits} ${t('pl_credits')}`}
    >
      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
        strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M10 3.5 11.7 8 16.2 9.7 11.7 11.4 10 15.9 8.3 11.4 3.8 9.7 8.3 8Z" />
        <path d="M17.5 14.2 18.4 16.4 20.6 17.3 18.4 18.2 17.5 20.4 16.6 18.2 14.4 17.3 16.6 16.4Z" />
      </svg>
      <span className="crb-n">{credits}</span>
      {/* NUMBER FIRST, then the word: "9980 credits". `pl_credits` is a noun in
          the form that follows a count — 'кредитов' in ru is genitive plural,
          which only reads correctly after the number — so label-first would be
          wrong Russian and wrong Armenian. It also matches the pack cards on
          /plans, which already stack the count above this same word.

          Shown only where the sparkle is hidden (see the CSS): one or the other
          always says what the number is, and on a desktop header with a search
          box, a bell and an avatar beside it, the icon is the cheaper of the
          two. */}
      <span className="crb-label">{t('pl_credits')}</span>
    </Link>
  );
}
